import { useEffect, useRef, useState } from 'react';
import { initialValues, validationSchema } from './formData';
import { useOrbitFormSection } from '../hooks/useOrbitFormSection';
import { OrbitPrivacyConsentProps } from '../sectionProps';

export const useOrbitPrivacyConsent = ({
    onChangeFormik,
    readOnly,
    seedValues,
    seededAcceptTerms,
}: OrbitPrivacyConsentProps) => {
    const [open, setOpen] = useState(false);

    const { formik } = useOrbitFormSection({
        initialValues,
        validationSchema,
        onChangeFormik,
        readOnly,
        seedValues,
    });

    const acceptTermsSeeded = useRef(false);

    useEffect(() => {
        if (acceptTermsSeeded.current || readOnly) return;
        if (seededAcceptTerms === undefined) return;
        acceptTermsSeeded.current = true;
        formik.setFieldValue('acceptTerms', seededAcceptTerms);
    }, [seededAcceptTerms, readOnly]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return {
        formik,
        open,
        handleOpen,
        handleClose,
    };
};
